import { requireById } from './dom'

/** How long the assistant "types" before answering, in ms. */
const REPLY_DELAY = 950

interface Ask {
  /** Quick-reply chip text — what the guest sends. */
  chip: string
  /** The assistant's answer; multiple entries become separate bubbles. */
  replies: string[]
  /** Small system line shown under the answer (what happened backstage). */
  note?: string
  /** A follow-up chip the answer unlocks. */
  unlocks?: Ask
}

const ASKS: Ask[] = [
  {
    chip: 'Anything tomorrow morning?',
    replies: [
      "Tomorrow's 9:00 am Morning Whale Cruise has 14 seats left. Wednesday is down to its last 3, so tomorrow's the pick. Want me to hold a couple while you decide?",
    ],
    unlocks: {
      chip: 'Yes — hold 2 seats',
      replies: [
        "Done — 2 seats held for 24 hours (hold #H-482). I've texted you the link to confirm. Berth 4 at the marina, 8:45 am — the kiosk does a good flat white from 8. ☕",
      ],
      note: 'That hold is already in the operator’s calendar — Viator now shows 12 seats.',
    },
  },
  {
    chip: 'Will we actually see whales?',
    replies: [
      "It's peak humpback season — the skipper's log shows whales on 27 of the last 28 trips. And if the ocean somehow keeps them hidden, your next cruise is free.",
    ],
  },
  {
    chip: 'Is it OK for a 3-year-old?',
    replies: [
      'Absolutely — all ages welcome. Under-3s cruise free on your lap, the 9 am run is the calmest for little ones, and we carry toddler-size life jackets on board.',
    ],
  },
  {
    chip: '明日の朝、大人2人で空いていますか？',
    replies: [
      'はい、明日9時のモーニング・ホエールクルーズは空席がございます。大人2名様でお席をお取り置きしましょうか？',
    ],
    note: 'Replied in Japanese — guests book in their own language, out of the box.',
  },
]

/**
 * The guest-facing website chat: quick-reply chips stand in for typing, and
 * each answer shows what happened backstage. Everything is scripted in ASKS —
 * nothing leaves the page.
 */
export function initGuestChat(): void {
  const log = requireById('gclog')
  const chipRow = requireById('gcchips')

  function addBubble(from: 'guest' | 'bot', text: string): HTMLElement {
    const bubble = document.createElement('div')
    bubble.className = `gmsg ${from}`
    bubble.textContent = text
    log.append(bubble)
    log.scrollTop = log.scrollHeight
    return bubble
  }

  function addNote(text: string): void {
    const note = document.createElement('div')
    note.className = 'gnote mono'
    note.textContent = text
    log.append(note)
    log.scrollTop = log.scrollHeight
  }

  function makeChip(ask: Ask): HTMLButtonElement {
    const chip = document.createElement('button')
    chip.type = 'button'
    chip.className = 'gchip'
    chip.textContent = ask.chip
    chip.addEventListener('click', () => {
      chip.remove()
      addBubble('guest', ask.chip)

      const typing = addBubble('bot', '')
      typing.classList.add('typing')
      typing.innerHTML = '<i></i><i></i><i></i>'

      window.setTimeout(() => {
        typing.classList.remove('typing')
        typing.textContent = ask.replies[0] ?? ''
        for (const extra of ask.replies.slice(1)) addBubble('bot', extra)
        if (ask.note) addNote(ask.note)
        if (ask.unlocks) chipRow.prepend(makeChip(ask.unlocks))
        log.scrollTop = log.scrollHeight
      }, REPLY_DELAY)
    })
    return chip
  }

  chipRow.replaceChildren(...ASKS.map(makeChip))
}
